import { QueryErrorBoundary } from '@components/errors/QueryErrorBoundary'
import { ParentPage } from '@features/parent-page/components/ParentPage'
import { createFileRoute } from '@tanstack/react-router'
import { LoadingIndicator } from '@ui/LoadingIndicator'
import { Suspense } from 'react'

export const Route = createFileRoute('/_layout/parents/$parentId')({
  component: RouteComponent,
})

function RouteComponent() {
    return (
        <QueryErrorBoundary title='Failed to load parent'>
            <Suspense fallback={<LoadingIndicator resource='parent'/>}>
                <ParentPage />
            </Suspense>
        </QueryErrorBoundary>
    )
}
